module.exports = __webpack_public_path__ + "img/2.e2938115.png";